"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var YouWillGet = function (_a) {
    var nextLevelInfo = _a.nextLevelInfo;
    var t = (0, next_intl_1.useTranslations)('translation');
    var prizes = (0, swr_hooks_1.usePrizesByLevel)(nextLevelInfo);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.greyText }, t('youWillGet')),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.prizesContainer, " ").concat((prizes === null || prizes === void 0 ? void 0 : prizes.length) === 1 ? styles_module_scss_1.default.onePrize : styles_module_scss_1.default.twoPrizes), style: {
                justifyContent: (prizes === null || prizes === void 0 ? void 0 : prizes.length) && (prizes === null || prizes === void 0 ? void 0 : prizes.length) > 1 ? 'space-between' : 'center',
            } }, prizes &&
            prizes.map(function (item, idx) { return (react_1.default.createElement("div", { key: item.value + idx },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.image, src: item.image, alt: item.value }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.prizeItem, key: "prizeNextLevel".concat(idx) }, item.value),
                    item.betAmount && (react_1.default.createElement("div", { className: styles_module_scss_1.default.greyText, style: { fontSize: '11px' } }, item.betAmount)),
                    item.wager && (react_1.default.createElement("div", { className: styles_module_scss_1.default.greyText, style: { fontSize: '11px' } }, item.wager))))); }))));
};
exports.default = YouWillGet;
